import { SxProps } from '@mui/material';

export const wrapper: SxProps = {
  mt: 3,
  mx: 'auto',
  maxWidth: 500,
};
